module.exports = __webpack_public_path__ + "static/img/erwx.03d8f273.png";